<template>
  <div class="modal fade" id="confirm-stop-use-warehouse-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <p>セルモン倉庫がご利用可能となりました。</p>
          <p>「倉庫管理を開く」ボタンより、セルモン倉庫をご利用ください。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    $('#confirm-stop-use-warehouse-modal').modal('show')
    $('#confirm-stop-use-warehouse-modal').on('hidden.bs.modal', (e) => {
      if (!$('#myModal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouses/RegisteredWarehouseModal.vue